<button type="button" class="btn btn-primary cst_mlt" (click)="clickOnMilitary()">Military</button>

<div class="modal fade" bsModal #MilitaryModal="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Military Information</h5>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal"
          (click)="onCancelMilitary()" id="military-close-button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <app-call-script [section]="section"></app-call-script>
        </div>

        <form [formGroup]="militaryForm">
          <div class="row mb-4">
            <div class="col-md-3">
              <label>Service Member Name@if (isRequired('ServiceMemberName')) {
                <span class="required"
                >*</span>
              }</label>
              <input type="text" class="form-control" maxLength='100' formControlName="ServiceMemberName" appHighlightCallScriptFields
                [fieldName]="'ServiceMemberName'" [linkedFieldsList]="militaryInfoCallScriptFields" >
                @if (militaryForm.get('ServiceMemberName').errors  && (militaryForm.get('ServiceMemberName').dirty || militaryForm.get('ServiceMemberName').touched)) {
                  <div
                    >
                    @if (militaryForm.get('ServiceMemberName').errors.required) {
                      <span
                        class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'ServiceMemberName'"
                        [RequiredList]="militaryInfoReqList"
                        >
                        Service Member Name is required
                      </span>
                    }
                    @if (militaryForm.get('ServiceMemberName').errors.whitespace) {
                      <span class="alert alert-danger d-flex mb-0"
                        >
                        Invalid input
                      </span>
                    }
                  </div>
                }
              </div>
              <div class="col-md-3">
                <label for="">DOD #
                  @if (isRequired('DOD')) {
                    <span class="required">*</span>
                  }
                </label>
                <input type="text" class="form-control" formControlName="DOD" maxlength="15"
                  appHighlightCallScriptFields [fieldName]="'DOD'"
                  [linkedFieldsList]="militaryInfoCallScriptFields">
                  @if (militaryForm.get('DOD').errors  && (militaryForm.get('DOD').dirty || militaryForm.get('DOD').touched)) {
                    <div
                      >
                      @if (militaryForm.get('DOD').errors.required) {
                        <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'DOD'"
                          [RequiredList]="militaryInfoReqList"
                          >DOD
                        Number is required</span>
                      }
                      @if (militaryForm.get('DOD').errors.whitespace) {
                        <span class="alert alert-danger d-flex mb-0"
                          >
                        Invalid input </span>
                      }
                    </div>
                  }
                </div>
                <div class="col-md-3">
                  <label>Active Duty/Deployment Start Date@if (isRequired('MilitaryDeploymentDate')) {
                    <span class="required"
                    >*</span>
                  }
                </label>
                <ejs-datepicker class="form-control p-0 h-auto" format="MM/dd/yyyy" [allowEdit]=false placeholder='Select Date'
                  (ngModelChange)="onChangeMilitaryDeploymentDate($event)" id="MilitaryDeploymentDate"
                  formControlName="MilitaryDeploymentDate" (change)="militaryDeploymentDateChange($event.value)" appHighlightCallScriptFields
                [fieldName]="'MilitaryDeploymentDate'" [linkedFieldsList]="militaryInfoCallScriptFields" ></ejs-datepicker>
                @if (militaryForm.get('MilitaryDeploymentDate').errors && (militaryForm.get('MilitaryDeploymentDate').dirty || militaryForm.get('MilitaryDeploymentDate').touched) && militaryForm.get('MilitaryDeploymentDate').validator !== null) {
                  <div
                    >
                    @if (militaryForm.get('MilitaryDeploymentDate').errors.required) {
                      <span class="alert alert-danger d-flex mb-0"
                        >Military
                      Deployment Date is Required</span>
                    }
                  </div>
                }
              </div>
              <div class="col-md-3">
                <label>Military Id Exp Date@if (isRequired('MilitaryIdExpDate')) {
                  <span class="required"
                  >*</span>
                }
              </label>
              <ejs-datepicker class="form-control p-0 h-auto" format='MM/dd/yyyy' placeholder='Select Date'
                (ngModelChange)="onChangeMilitaryExpDate($event)" id="MilitaryIdExpDate"
                formControlName="MilitaryIdExpDate" [allowEdit]=false
                (change)="militaryexpdatechange($event.value)" appHighlightCallScriptFields
                [fieldName]="'MilitaryIdExpDate'" [linkedFieldsList]="militaryInfoCallScriptFields">
              </ejs-datepicker>
              @if (militaryForm.get('MilitaryIdExpDate').errors &&
                (militaryForm.get('MilitaryIdExpDate').dirty || militaryForm.get('MilitaryIdExpDate').touched)
                && militaryForm.get('MilitaryIdExpDate').validator !== null) {
                <div>
                  @if (militaryForm.get('MilitaryIdExpDate').errors.required) {
                    <span class="alert alert-danger d-flex mb-0"
                      >
                    Military Id Exp Date is required</span>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="">Rank@if (isRequired('MilitaryRank')) {
                <span class="required">*</span>
              }</label>
              <input type="text" class="form-control" formControlName="MilitaryRank" maxlength="15"
                appHighlightCallScriptFields [fieldName]="'MilitaryRank'"
                [linkedFieldsList]="militaryInfoCallScriptFields">
                @if (militaryForm.get('MilitaryRank').errors  && (militaryForm.get('MilitaryRank').dirty || militaryForm.get('MilitaryRank').touched)) {
                  <div
                    >
                    @if (militaryForm.get('MilitaryRank').errors.required) {
                      <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'MilitaryRank'"
                        [RequiredList]="militaryInfoReqList"
                        >Rank
                      is required</span>
                    }
                    @if (militaryForm.get('MilitaryRank').errors.whitespace) {
                      <span class="alert alert-danger d-flex mb-0"
                        >
                      Invalid input </span>
                    }
                  </div>
                }
              </div>
              <div class="col-md-3">
                <label>Military Unit Name@if (isRequired('MilitaryUnitName')) {
                  <span class="required">*</span>
                }</label>
                <input type="text" class="form-control" maxLength='50' formControlName="MilitaryUnitName" appHighlightCallScriptFields
                  [fieldName]="'MilitaryUnitName'" [linkedFieldsList]="militaryInfoCallScriptFields" >
                  @if (militaryForm.get('MilitaryUnitName').errors  && (militaryForm.get('MilitaryUnitName').dirty || militaryForm.get('MilitaryUnitName').touched) ) {
                    <div
                      >
                      @if (militaryForm.get('MilitaryUnitName').errors.required) {
                        <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'MilitaryUnitName'"
                          [RequiredList]="militaryInfoReqList">
                          Military Unit is required
                        </span>
                      }
                      @if (militaryForm.get('MilitaryUnitName').errors.whitespace) {
                        <span class="alert alert-danger d-flex mb-0">
                          Invalid input
                        </span>
                      }
                    </div>
                  }
                </div>
                <div class="col-md-3">
                  <label>Military Branch@if (isRequired('MilitaryBranch')) {
                    <span class="required"
                    >*</span>
                  }</label>
                  <input type="text" class="form-control" maxLength='50' formControlName="MilitaryBranch"
                    appHighlightCallScriptFields [fieldName]="'MilitaryBranch'"
                    [linkedFieldsList]="militaryInfoCallScriptFields">
                    @if (militaryForm.get('MilitaryBranch').errors  && (militaryForm.get('MilitaryBranch').dirty || militaryForm.get('MilitaryBranch').touched)) {
                      <div
                        >
                        @if (militaryForm.get('MilitaryBranch').errors.required) {
                          <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'MilitaryBranch'"
                            [RequiredList]="militaryInfoReqList"
                            >
                            Military Branch is required
                          </span>
                        }
                        @if (militaryForm.get('MilitaryBranch').errors.whitespace) {
                          <span class="alert alert-danger d-flex mb-0"
                            >
                            Invalid input
                          </span>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-md-3">


                    <label>Military Base@if (isRequired('MilitaryBase')) {
                      <span class="required"
                      >*</span>
                    }</label>
                    <input type="text" class="form-control" maxLength='50' formControlName="MilitaryBase"
                      appHighlightCallScriptFields [fieldName]="'MilitaryBase'"
                      [linkedFieldsList]="militaryInfoCallScriptFields">
                      @if (militaryForm.get('MilitaryBase').errors  && (militaryForm.get('MilitaryBase').dirty || militaryForm.get('MilitaryBase').touched)) {
                        <div
                          >
                          @if (militaryForm.get('MilitaryBase').errors.required) {
                            <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'MilitaryBase'"
                              [RequiredList]="militaryInfoReqList"
                              >
                              Military Base is required
                            </span>
                          }
                          @if (militaryForm.get('MilitaryBase').errors.whitespace) {
                            <span class="alert alert-danger d-flex mb-0"
                              >
                              Invalid input
                            </span>
                          }
                        </div>
                      }

                    </div>
                  </div>

                  <h6 class="sectionTitle my-3">Commanding Officer Information </h6>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label for="">First Name@if (isRequired('COFirstName')) {
                        <span class="required"
                        >*</span>
                      }</label>
                      <input type="text" class="form-control" formControlName="COFirstName" maxlength="50"
                        appHighlightCallScriptFields [fieldName]="'COFirstName'"
                        [linkedFieldsList]="militaryInfoCallScriptFields">
                        @if (militaryForm.get('COFirstName').errors  && (militaryForm.get('COFirstName').dirty || militaryForm.get('COFirstName').touched)) {
                          <div
                            >
                            @if (militaryForm.get('COFirstName').errors.required) {
                              <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'COFirstName'"
                                [RequiredList]="militaryInfoReqList"
                                >First
                              Name is required</span>
                            }
                            @if (militaryForm.get('COFirstName').errors.whitespace) {
                              <span class="alert alert-danger d-flex mb-0"
                                >
                              Invalid input </span>
                            }
                          </div>
                        }
                      </div>
                      <div class="col-md-4 pt-3 pt-md-0">
                        <label for="">Last Name@if (isRequired('COLastName')) {
                          <span class="required"
                          >*</span>
                        }</label>
                        <input type="text" class="form-control" formControlName="COLastName" maxlength="50"
                          appHighlightCallScriptFields [fieldName]="'COLastName'"
                          [linkedFieldsList]="militaryInfoCallScriptFields">
                          @if (militaryForm.get('COLastName').errors  && (militaryForm.get('COLastName').dirty || militaryForm.get('COLastName').touched)) {
                            <div
                              >
                              @if (militaryForm.get('COLastName').errors.required) {
                                <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'COLastName'"
                                  [RequiredList]="militaryInfoReqList"
                                  >Last
                                Name is required</span>
                              }
                              @if (militaryForm.get('COLastName').errors.whitespace) {
                                <span class="alert alert-danger d-flex mb-0"
                                  >
                                Invalid input </span>
                              }
                            </div>
                          }
                        </div>
                        <div class="col-md-4 pt-3 pt-md-0">
                          <label for="">Rank@if (isRequired('CORank')) {
                            <span class="required">*</span>
                          }</label>
                          <input type="text" class="form-control" formControlName="CORank" maxlength="15"
                            appHighlightCallScriptFields [fieldName]="'MilitaryRank'"
                            [linkedFieldsList]="militaryInfoCallScriptFields">
                            @if (militaryForm.get('CORank').errors  && (militaryForm.get('CORank').dirty || militaryForm.get('CORank').touched)) {
                              <div
                                >
                                @if (militaryForm.get('CORank').errors.required) {
                                  <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'CORank'"
                                    [RequiredList]="militaryInfoReqList"
                                    >Rank
                                  is required</span>
                                }
                                @if (militaryForm.get('CORank').errors.whitespace) {
                                  <span class="alert alert-danger d-flex mb-0"
                                    >
                                  Invalid input </span>
                                }
                              </div>
                            }
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-md-8">
                            <label for="">Address@if (isRequired('COAddress')) {
                              <span class="required">*</span>
                            }</label>
                            <textarea rows="3" class="form-control" formControlName="COAddress" maxlength="150"
                              appHighlightCallScriptFields [fieldName]="'COAddress'"
                            [linkedFieldsList]="militaryInfoCallScriptFields"></textarea>
                            @if (militaryForm.get('COAddress').errors  && (militaryForm.get('COAddress').dirty || militaryForm.get('COAddress').touched)) {
                              <div
                                >
                                @if (militaryForm.get('COAddress').errors.required) {
                                  <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'COAddress'"
                                    [RequiredList]="militaryInfoReqList"
                                    >Address
                                  is required</span>
                                }
                                @if (militaryForm.get('COAddress').errors.whitespace) {
                                  <span class="alert alert-danger d-flex mb-0"
                                    >
                                  Invalid input </span>
                                }
                              </div>
                            }
                          </div>
                          <div class="col-md-4 pt-3 pt-md-0">
                            <label for="">Country@if (isRequired('COCountry')) {
                              <span class="required">*</span>
                            }</label>
                            <select class="form-select" formControlName="COCountry"
                              (change)="onMilitaryCountryChange($event.target.value, true)"
                              appHighlightCallScriptFields [fieldName]="'COCountry'"
                              [linkedFieldsList]="militaryInfoCallScriptFields">
                              <option value="" selected>Select</option>
                              @for (cc of countryList; track cc) {
                                <option [value]="cc.Id">
                                {{cc.Name}}</option>
                              }
                            </select>
                            @if (militaryForm.get('COCountry').errors  && (militaryForm.get('COCountry').dirty || militaryForm.get('COCountry').touched)) {
                              <div
                                >
                                @if (militaryForm.get('COCountry').errors.required) {
                                  <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'COCountry'"
                                    [RequiredList]="militaryInfoReqList"
                                    >Country
                                  is required</span>
                                }
                              </div>
                            }
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-md-4">
                            <label for="">State / Province@if (!emptyStateList && isRequired('COState')) {
                              <span class="required"
                              >*</span>
                            }</label>
                            <select class="form-select" formControlName="COState" appHighlightCallScriptFields
                              [fieldName]="'COState'" [linkedFieldsList]="militaryInfoCallScriptFields">
                              @if (!emptyStateList) {
                                <option value="" selected>Select</option>
                              }
                              @if (emptyStateList) {
                                <option value="0">--</option>
                              }
                              @for (st of stateListMilitary; track st) {
                                <option [value]="st.Id">
                                  {{st.Name}}
                                </option>
                              }
                            </select>
                            @if (militaryForm.get('COState').errors  && (militaryForm.get('COState').dirty || militaryForm.get('COState').touched)) {
                              <div
                                >
                                @if (militaryForm.get('COState').errors.required) {
                                  <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'COState'"
                                    [RequiredList]="militaryInfoReqList"
                                    >State / Province
                                  is required</span>
                                }
                              </div>
                            }
                          </div>
                          <div class="col-md-4 pt-3 pt-md-0">
                            <label for="">City@if (isRequired('COCity')) {
                              <span class="required">*</span>
                            }</label>
                            <input type="text" class="form-control" formControlName="COCity" maxlength="30"
                              appHighlightCallScriptFields [fieldName]="'COCity'"
                              [linkedFieldsList]="militaryInfoCallScriptFields">
                              @if (militaryForm.get('COCity').errors  && (militaryForm.get('COCity').dirty || militaryForm.get('COCity').touched)) {
                                <div
                                  >
                                  @if (militaryForm.get('COCity').errors.required) {
                                    <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'COCity'"
                                      [RequiredList]="militaryInfoReqList"
                                      >City
                                    is required</span>
                                  }
                                  @if (militaryForm.get('COCity').errors.whitespace) {
                                    <span class="alert alert-danger d-flex mb-0"
                                      >
                                    Invalid input </span>
                                  }
                                </div>
                              }
                            </div>
                            <div class="col-md-4 pt-3 pt-md-0">
                              <label for="">Zip / Postal Code@if (isRequired('COZipCode')) {
                                <span class="required"
                                >*</span>
                              }</label>
                              <input type="text" class="form-control" formControlName="COZipCode" maxlength="15" (keypress)="validateZipInput($event)"
                                appHighlightCallScriptFields [fieldName]="'COZipCode'"
                                [linkedFieldsList]="militaryInfoCallScriptFields">
                                @if (militaryForm.get('COZipCode').errors  && (militaryForm.get('COZipCode').dirty || militaryForm.get('COZipCode').touched)) {
                                  <div
                                    >
                                    @if (militaryForm.get('COZipCode').errors.required) {
                                      <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'COZipCode'"
                                        [RequiredList]="militaryInfoReqList"
                                        >Zip / Postal Code is
                                      required</span>
                                    }
                                  </div>
                                }
                              </div>

                            </div>

                            <div class="row ">
                              <div class="col-md-4">
                                <label>Cell Phone
                                  @if (isRequired('COCellPhone')) {
                                    <span class="required">*</span>
                                  }
                                </label>
                                <div class="form-group mb-0">
                                  <div class="phone_code">
                                    <select class="form-select" formControlName="COCellPhoneDialInCode"
                                      appHighlightCallScriptFields [fieldName]="'COCellPhoneDialInCode'"
                                      [linkedFieldsList]="militaryInfoCallScriptFields">
                                      <option value="" selected hidden>Select</option>
                                      @for (ct of countryList; track ct) {
                                        <option [value]="ct.Id">
                                        {{ct.DialInCode}}</option>
                                      }
                                    </select>
                                  </div>
                                  <div class="homephone_numb_field">
                                    <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputCellPhone"
                                      formControlName="COCellPhone" cssClass="form-control p-0"
                                      (focus)="onStartfocus($event)" appHighlightCallScriptFields
                                      [fieldName]="'COCellPhone'" [linkedFieldsList]="militaryInfoCallScriptFields">
                                    </ejs-maskedtextbox>
                                    @if ( militaryForm.get('COCellPhone').errors  && (militaryForm.get('COCellPhone').dirty || militaryForm.get('COCellPhone').touched)) {
                                      <div
                                        >
                                        @if (militaryForm.get('COCellPhone').errors.required) {
                                          <span class="alert alert-danger d-flex mb-0" isMandatory
                                            [fieldName]="'COCellPhone'" [RequiredList]="militaryInfoReqList"
                                            >CellPhone
                                          is required</span>
                                        }
                                        @if (militaryForm.get('COCellPhone').errors.lessThanTen) {
                                          <span class="alert alert-danger d-flex mb-0"
                                            >Enter 10 digit
                                          Cellphone Number</span>
                                        }
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4 pt-3 pt-md-0">
                                <label for="Email">Email
                                  @if (isRequired('COEmail')) {
                                    <span class="required">*</span>
                                  }
                                </label>
                                <input type="text" class="form-control" formControlName="COEmail" maxlength="50"
                                  [pattern]="emailIdsPattern" (keypress)="restrictSpace($event)"
                                  appHighlightCallScriptFields [fieldName]="'COEmail'"
                                  [linkedFieldsList]="militaryInfoCallScriptFields">
                                  @if (militaryForm.get('COEmail').errors  && (militaryForm.get('COEmail').dirty || militaryForm.get('COEmail').touched)) {
                                    <div
                                      >
                                      @if (militaryForm.get('COEmail').errors.pattern) {
                                        <span class="alert alert-danger d-flex mb-0"
                                          i18n="@@Valid_E-mail"> Enter
                                    Valid E-Mail Ids separated by comma or semi colon</span>
                                      }
                                      @if (militaryForm.get('COEmail').errors.required) {
                                        <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'COEmail'"
                                          [RequiredList]="militaryInfoReqList"
                                        >E-Mail is required</span>
                                      }
                                    </div>
                                  }
                                </div>
                                <div class="col-md-4 pt-3 pt-md-0">
                                  <label>Fax
                                    @if (isRequired('COFax')) {
                                      <span class="required">*</span>
                                    }
                                  </label>
                                  <div class="form-group mb-0">
                                    <div class="phone_code">
                                      <select class="form-select" formControlName="COFaxDialInCode"
                                        appHighlightCallScriptFields [fieldName]="'COFaxDialInCode'"
                                        [linkedFieldsList]="militaryInfoCallScriptFields">
                                        <option value="" selected hidden>Select</option>
                                        @for (ct of countryList; track ct) {
                                          <option [value]="ct.Id">
                                          {{ct.DialInCode}}</option>
                                        }
                                      </select>
                                    </div>
                                    <div class="homephone_numb_field">
                                      <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputFax"
                                        formControlName="COFax" cssClass="form-control p-0"
                                        (focus)="onStartfocus($event)" appHighlightCallScriptFields
                                        [fieldName]="'COFax'"
                                      [linkedFieldsList]="militaryInfoCallScriptFields"></ejs-maskedtextbox>
                                      @if ( militaryForm.get('COFax').errors  && (militaryForm.get('COFax').dirty || militaryForm.get('COFax').touched)) {
                                        <div
                                          >
                                          @if (militaryForm.get('COFax').errors.required) {
                                            <span class="alert alert-danger d-flex mb-0" isMandatory [fieldName]="'COFax'"
                                              [RequiredList]="militaryInfoReqList"
                                            >Fax is required</span>
                                          }
                                          @if (militaryForm.get('COFax').errors.lessThanTen) {
                                            <span class="alert alert-danger d-flex mb-0"
                                              >Enter 10 digit Fax
                                            Number</span>
                                          }
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary me-3"
                            (click)="cancelmilitaryForm(template1)">Cancel</button>
                            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" id="military-save-button"
                            [disabled]="!(militaryForm.valid && militaryForm.dirty)" (click)="onMilitarySave()">Save</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ng-template #template1>
                      <div class="modal-header">
                        <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
                        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <p class="mb-0" i18n="@@sureCancel">
            Are you sure you want to cancel? Any data modifications will not be saved.
        </p>
                      </div>
                      <div class="modal-footer">
                        <button class="btn btn-outline-primary me-3" type="button" (click)="modalRef.hide()" i18n="@@No">No</button>
                        <button class="btn btn-primary" type="button"
                        (click)="onCancelMilitary()" i18n="@@Yes">Yes</button>
                      </div>
                    </ng-template>
